import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, ReferenceLine, } from 'recharts';
import { LRL_TOKENS } from '@lrl/ui-tokens';
/**
 * Recharts LineChart showing ELO trace.
 * 320×120 viewbox. X-axis = match index. Y-axis = elo value.
 */
export function EloHistoryChart({ history }) {
    if (history.length === 0) {
        return (_jsx("div", { className: "h-[120px] flex items-center justify-center text-sm text-foreground-soft", children: "\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445 ELO" }));
    }
    const points = history.map((h, i) => ({
        index: i + 1,
        elo_after: h.elo_after,
        elo_before: h.elo_before,
        kind: h.kind,
        delta: h.delta,
    }));
    // Add starting point (history is non-empty, guarded above)
    const firstPoint = history[0];
    const startElo = firstPoint ? firstPoint.elo_before : 0;
    const chartData = [
        { index: 0, elo_after: startElo, elo_before: startElo, kind: 'start', delta: 0 },
        ...points,
    ];
    const avgElo = Math.round(chartData.reduce((s, p) => s + p.elo_after, 0) / chartData.length);
    return (_jsx(ResponsiveContainer, { width: "100%", height: 120, children: _jsxs(LineChart, { data: chartData, margin: { top: 8, right: 8, bottom: 8, left: 0 }, children: [_jsx(XAxis, { dataKey: "index", tick: { fontSize: 9, fontFamily: LRL_TOKENS.mono, fill: LRL_TOKENS.inkMuted }, axisLine: false, tickLine: false }), _jsx(YAxis, { domain: ['auto', 'auto'], tick: { fontSize: 9, fontFamily: LRL_TOKENS.mono, fill: LRL_TOKENS.inkMuted }, axisLine: false, tickLine: false, width: 36 }), _jsx(Tooltip, { contentStyle: {
                        fontSize: 11,
                        fontFamily: LRL_TOKENS.mono,
                        background: LRL_TOKENS.card,
                        border: `1px solid ${LRL_TOKENS.rule}`,
                        borderRadius: LRL_TOKENS.rSm,
                    }, formatter: (value, name) => name === 'elo_after' ? [value, 'ELO'] : [value, name], labelFormatter: (idx) => `Матч ${idx}` }), _jsx(ReferenceLine, { y: avgElo, stroke: LRL_TOKENS.rule, strokeDasharray: "3 3" }), _jsx(Line, { type: "monotone", dataKey: "elo_after", stroke: LRL_TOKENS.primary, strokeWidth: 1.5, dot: false, activeDot: { r: 3, fill: LRL_TOKENS.primary }, name: "ELO" })] }) }));
}
